import React from 'react';
import { HelmetContext } from '@okapi/helmet-react';
import { useSelector } from 'react-redux';
import { getStorePathname } from 'common/selectors/location';
import { JsonLdContent, JSONDataHardwareStore } from '@navi-toolbox/seo';
import { getRegionId, getRegions, getSeoProperties } from 'features/page-model/ducks/get-model';
import { getStoreDetail } from 'features/store/ducks/get-store-by-id';
import { getWorkingHours } from './get-working-hours';

const QA_LOCATOR = 'json_ld_hardwareStore_script';
const STORE_IMAGE =
  'https://cdn.lemanapro.ru/lmru/image/upload/fudzi/navigation-microfronts/logo_seo.svg/logo_seo.svg';

type Props = {
  context: HelmetContext;
};

export const StoreJsonLdMarkup = (props: Props) => {
  const storePathname = useSelector(getStorePathname);
  const storeDetail = useSelector(getStoreDetail) || {};
  const seoProperties = useSelector(getSeoProperties);

  const regionId = useSelector(getRegionId) ?? '';
  const regions = useSelector(getRegions);
  const currentRegion = regions.find((r) => r.regionId === regionId);

  if (storePathname === null) {
    return null;
  }

  const content: JSONDataHardwareStore = {
    name: seoProperties?.h1,
    image: STORE_IMAGE,
    address: {
      addressLocality: currentRegion?.regionName ?? '',
      streetAddress: storeDetail.address ?? '',
    },
    geo: {
      latitude: storeDetail.geocoordinateLatitude ?? '',
      longitude: storeDetail.geocoordinateLongitude ?? '',
    },
    openingHours: getWorkingHours(storeDetail),
    email: storeDetail.b2bEmail,
    telephone: storeDetail.b2cPhone,
    url: seoProperties?.canonicalURL ?? '',
    sameAs: [storeDetail.vkLink ?? ''],
  };

  return <JsonLdContent content={{ hardwareStore: content }} context={props.context} dataQa={QA_LOCATOR} />;
};
